import Api from "./index";
import { endPoints, requestType } from "../constants/Variables";

export const createTeamMember = (params) => {
  return Api(endPoints.createTeamMember, params, requestType.POST);
};
export const deleteTeams = (id) => {
  return Api(`${endPoints.deleteTeams}/${id}`, null, requestType.POST);
};
export const fetchAllTeamMembers = (id) => {
  return Api(`${endPoints.fetchAllTeamMembers}/${id}`, null, requestType.GET);
};
export const updateTeamMembers = (id, params) => {
  return Api(`${endPoints.updateTeamMembers}/${id}`, params, requestType.PUT);
};
export const teamSchedule = (id) => {
  return Api(`${endPoints.teamSchedule}/${id}`, null, requestType.GET);
};

// Teams By Services
export const featchAllTeam = (params) => {
  return Api(endPoints.featchAllTeam, params, requestType.POST);
};
export const fetchProTeams = (params) => {
  return Api(endPoints.fetchProTeams, params, requestType.POST);
};
